import React from 'react';

const Complete = () => {
    return (
        <div>
            <section
                className="section section-lead section-bold section-theme-autoheight section-theme-transparent section-eyebrow-include section-theme-indent-bottom-inside-md section-theme-indent-bottom-inside-lg-option section-theme-indent-no-bottom-outside  section-39 section-i2">
                <div className="container">
                    <div className="row">
                        <div
                            className="section-content-wrapper col-lg-10 col-lg-offset-1 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="section-content">
                                <div className="section-content-caption"><p className="section-eyebrow">100% Complete
                                    Set</p><h2>Next step.</h2>
                                    <p>After issuing 100% of NFT CyberBearz Army, a combat system will be introduced to
                                        open up the opportunity for you to use your bears in raffles with a lot of
                                        various awards.</p>
                                    <blockquote><p>We are going to create an internal ecosystem for you to increase the
                                        trading and exchange value of your NFTs.</p></blockquote>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-option container">
                    <div className="strip-wrapper row">
                        <div
                            className="col-lg-12 col-lg-offset-0 col-md-8 col-md-offset-2  col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="strip-items strip-center">
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-circle icon-number icon-one"></figure>
                                    <div className="strip-caption"><h3 className="h5">Collect fighters!</h3>
                                        <p>The ranks and ammunition of bears in your squad will give you some bonuses
                                            for raffles.</p>

                                    </div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-circle icon-number icon-two"></figure>
                                    <div className="strip-caption"><h3 className="h5">Play
                                    </h3><p>Take part in battles for rewards by using your bear squads in various
                                        combinations.</p></div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-circle icon-number icon-three"></figure>
                                    <div className="strip-caption"><h3 className="h5">Speculate</h3>
                                        <p>You can exchange and trade your bears to form squads.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Complete;